import { SEED_IMAGES } from "@dc-ireland/shared"

export type MinistryGroup = {
  name: string
  description: string
}

export type ServicePoster = {
  label: string
  imageUrl: string
  zoomUrl?: string
  title?: string
  badge?: string
  detail?: string
  showAddress?: boolean
}

export type ChapterDefaults = {
  ministries: MinistryGroup[]
  sundayService: ServicePoster
  midweekService?: ServicePoster
}

const defaultMinistries: MinistryGroup[] = [
  {
    name: "Choir",
    description: "Leading worship through song — creating an atmosphere where hearts connect with God.",
  },
  {
    name: "Media Team",
    description: "Capturing and sharing our story through visual storytelling and creative production.",
  },
  {
    name: "Welfare",
    description: "Caring for members and the community through practical support and compassion.",
  },
  {
    name: "Prayer Requests",
    description: "Standing in the gap through intercession for the church, community, and nations.",
  },
]

const dublinMinistries: MinistryGroup[] = [
  {
    name: "Choir — DC Angels",
    description: "Leading worship through song — creating an atmosphere where hearts connect with God.",
  },
  {
    name: "Media Team",
    description: "Capturing and sharing our story through visual storytelling and creative production.",
  },
  {
    name: "Technical Team",
    description: "Supporting Sunday and midweek services through sound, lighting, and technical excellence.",
  },
  {
    name: "MVP/Consolidation Team",
    description: "Following up new believers and grounding them in faith through discipleship and care.",
  },
  {
    name: "Welfare Team",
    description: "Caring for members and the community through practical support and compassion.",
  },
  {
    name: "Prayer/Intercessory Team",
    description: "Standing in the gap through intercession for the church, community, and nations.",
  },
  {
    name: "Pastoral Team",
    description: "Shepherding the flock through care, counsel, and spiritual covering.",
  },
  {
    name: "DC Hype (Youth/Teens Ministry)",
    description: "Discipling young people and creating a space for teens to encounter God and grow.",
  },
  {
    name: "Admin/Finance",
    description: "Stewarding the house through administration, operations, and faithful financial management.",
  },
  {
    name: "Kings Kids (Children Ministry)",
    description: "Helping children know Jesus and grow in faith through teaching, worship, and fun.",
  },
]

const chapterDefaults: Record<string, ChapterDefaults> = {
  dublin: {
    ministries: dublinMinistries,
    sundayService: {
      label: "Sundays 10am - 12:15pm",
      imageUrl: SEED_IMAGES.chapters.dublin.serviceSunday,
    },
    midweekService: {
      label: "Midweek Service — Wednesdays 7:30pm - 8:30pm",
      imageUrl: SEED_IMAGES.chapters.dublin.serviceMidweek,
      zoomUrl: "https://us06web.zoom.us/j/4259097486?pwd=ak1XbmprdFBUQnRZOWszWU91VHdyUT09",
    },
  },
  cork: {
    ministries: defaultMinistries,
    sundayService: {
      label: "Sundays 10.30am - 1pm",
      imageUrl: SEED_IMAGES.chapters.cork.serviceSunday,
    },
    midweekService: {
      label: "Midweek Service — Wednesdays at 7pm - 8:30pm",
      imageUrl: SEED_IMAGES.chapters.cork.serviceMidweek,
      zoomUrl: "https://us05web.zoom.us/j/89403348192?pwd=zdqg6SqsEg7MKambJ4Z2wUKOHCOddM.1",
    },
  },
  drogheda: {
    ministries: [],
    sundayService: {
      label: "Sundays at 5pm",
      imageUrl: SEED_IMAGES.chapters.drogheda.hero,
    },
    midweekService: {
      label: "Wednesdays (online) at 7:30pm",
      imageUrl: SEED_IMAGES.chapters.drogheda.gallery[0],
      zoomUrl: "https://us06web.zoom.us/j/4259097486?pwd=ak1XbmprdFBUQnRZOWszWU91VHdyUT09",
    },
  },
  kerry: {
    ministries: [],
    sundayService: {
      title: "Believers Circle",
      label: "Sundays at 2:00pm",
      imageUrl: "/gallery/kerry/believers-circle.jpg",
    },
    midweekService: {
      title: "The Prayer Nest",
      badge: "Fri & Sat",
      label: "Fridays & Saturdays 9:00pm – 10:00pm",
      detail: "A non-denominational prayer platform for our families and children.",
      imageUrl: "/gallery/kerry/prayer-nest.jpg",
    },
  },
  sligo: {
    ministries: [],
    sundayService: {
      title: "Sunday Service",
      label: "Sundays at 10:00am",
      imageUrl: "/gallery/sligo/sunday-service.jpg",
    },
  },
  waterford: {
    ministries: [],
    sundayService: {
      title: "Sunday Service",
      label: "Sundays at 4:00pm",
      detail: "Butler Community Centre, Waterford & on Zoom. Meeting ID 872 7749 56886 · Passcode 04",
      imageUrl: "/gallery/waterford/sunday-service.jpg",
      zoomUrl: "https://zoom.us/j/872774956886",
      showAddress: true,
    },
    midweekService: {
      title: "Midweek Service",
      badge: "Wednesday",
      label: "Wednesdays at 7:00pm",
      detail: "Butler Community Centre, Waterford & on Zoom. Meeting ID 872 7749 56886 · Passcode 04",
      imageUrl: "/gallery/waterford/sunday-service.jpg",
      zoomUrl: "https://zoom.us/j/872774956886",
      showAddress: true,
    },
  },
}

export function getChapterDefaults(slug: string): ChapterDefaults | undefined {
  return chapterDefaults[slug]
}
